import SitePayContainer from "components/Site/Pay/SitePay.containerNew";

const SitePayPage = () => {
  return <SitePayContainer />;
};

export default SitePayPage;
